import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=8964%3A20679
 *
 * @param {SvgIconProps} props - svg props
 */
export const MoreButtonIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M4.91675 11.9999C4.91675 11.0833 5.66675 10.3333 6.58341 10.3333C7.50008 10.3333 8.25008 11.0833 8.25008 11.9999C8.25008 12.9166 7.50008 13.6666 6.58341 13.6666C5.66675 13.6666 4.91675 12.9166 4.91675 11.9999ZM12.0001 10.3333C11.0834 10.3333 10.3334 11.0833 10.3334 11.9999C10.3334 12.9166 11.0834 13.6666 12.0001 13.6666C12.9167 13.6666 13.6667 12.9166 13.6667 11.9999C13.6667 11.0833 12.9167 10.3333 12.0001 10.3333ZM17.4167 10.3333C16.5001 10.3333 15.7501 11.0833 15.7501 11.9999C15.7501 12.9166 16.5001 13.6666 17.4167 13.6666C18.3334 13.6666 19.0834 12.9166 19.0834 11.9999C19.0834 11.0833 18.3334 10.3333 17.4167 10.3333Z' fill='white'/>
        </SvgIcon>
    )
}

export default MoreButtonIcon
